export default __webpack_public_path__ + "static/media/back-icon-black.d9258b07.svg";